import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useOutletContext, useParams } from 'react-router-dom';

import { Button, Input, Spin } from 'antd';
import css from '@/pages/Login/Login.module.scss';

import { clearError, confirmRegistrUserLogin, registrUserLogin } from '@shared/store/Auth/actions';
import { selectAuth } from '@shared/store/Auth/selectors';
import { selectCompany } from '@shared/store/company/selectors';
import { domainCompanyid } from '@shared/utils/domainCompanyId';

import classNames from 'classnames';

const ConfirmRegisterMobile = () => {
  const { t } = useTranslation('mobileRegistation');
  const { id } = useParams();
  const { isLoadingImageLogo, imageLogo } = useOutletContext();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { company } = useSelector(selectCompany);
  const { error: errorText, timer, codeLength } = useSelector(selectAuth);

  const [disableTryAgain, setDisableTryAgain] = useState(true);
  const [seconds, setSeconds] = useState(timer);

  const time = timer;

  const sendData = JSON.parse(localStorage.getItem('registrData'));

  const handleInput = e => {
    dispatch(clearError());

    if (codeLength && e?.length === codeLength) {
      const data = e.join('');
      dispatch(
        confirmRegistrUserLogin({ id, code: data }, resp => {
          const url = new URL(resp.url);
          const token = url.searchParams.get('register');

          localStorage.removeItem('registrData');
          navigate(`/user-login/registration-page-data?token=${token}`, { replace: true });
        })
      );
    }
  };

  const handleTryAgain = () => {
    dispatch(
      registrUserLogin(
        {
          ...sendData,
          messageId: id,
        },
        resp => {
          setDisableTryAgain(true);
          setSeconds(time);
          navigate(`/user-login/mobile-registration/${resp.messageId}`, { replace: true });
        }
      )
    );
  };

  const goBack = () => {
    localStorage.removeItem('registrData');
    dispatch(clearError());
    navigate(`/user-login/mobile-registration`, { replace: true });
  };

  useEffect(() => {
    if (seconds > 0) {
      const intervalId = setInterval(() => {
        setSeconds(prevSeconds => prevSeconds - 1);
      }, 1000);

      return () => {
        clearInterval(intervalId);
      };
    } else {
      setDisableTryAgain(false);
    }
  }, [seconds]);

  useEffect(() => {
    return () => {
      localStorage.removeItem('registrData');
    };
  }, []);

  return (
    <div className={css['App-card-item']}>
      <div className={classNames(css['LoginPage-header'], css['LoginPage-header-mobile'])}>
        <Spin spinning={isLoadingImageLogo} wrapperClassName={css['LoginPage-header__logo']}>
          {!isLoadingImageLogo && <img src={imageLogo} alt='' />}
        </Spin>
        {company?.id !== domainCompanyid.ABSOLUTE && (
          <div className={css['LoginPage-slogan']}>{t('confirmMobile')}</div>
        )}
        <div className={css['LoginPage-header__subtitle']}>{t('confirmMobileRegistr')}</div>
        <div className={css['LoginPage-header__smsblock']}>
          {t('smsNumber')}
          <span>{sendData?.phone && sendData?.phone?.replace(sendData?.phone?.substring(2, 8), '******')}</span>
        </div>
      </div>
      <div className={css['LoginPage-header__otp']}>
        <Input.OTP
          className={css['Mobile-input-otp']}
          length={codeLength}
          onInput={handleInput}
          status={errorText?.length > 0 && 'error'}
        />
        {errorText && <div className={css['Mobile-input-error']}> {errorText}</div>}
      </div>

      <Button
        className={css['LoginPage-mobRegistr-tryAgain']}
        size='large'
        type={'link'}
        onClick={handleTryAgain}
        disabled={disableTryAgain}
      >
        {t('tryAgain')}
      </Button>

      {seconds > 0 && (
        <div className={css['LoginPage-mobRegistr-counter']}>{t('tryAgainCount', { count: seconds })}</div>
      )}

      <div className={css['LoginPage-label']}>
        <div className={css.LoginPage__toInfo} onClick={goBack}>
          {t('goBack')}
        </div>
      </div>
    </div>
  );
};

export default ConfirmRegisterMobile;
